import { ExamFormValues, PROCTORING_TYPE } from '@shared';
import { examsApi } from '../../App';

function enumKeyByValue(value: PROCTORING_TYPE) {
  return Object.keys(PROCTORING_TYPE)[Object.values(PROCTORING_TYPE).indexOf(value)];
}

export function getProctoringType(examAPI: examsApi.ExamAPI): string {
  if (
    examAPI.proctoringType === 'SECURE_BROWSER_ONLY_NO_PROCTORING' ||
    examAPI.exam.proctoringType === 'SECURE_BROWSER_ONLY_NO_PROCTORING'
  ) {
    return enumKeyByValue(PROCTORING_TYPE.SECURE_BROWSER_ONLY_NO_PROCTORING);
  }
  if (examAPI.exam.practice) {
    return enumKeyByValue(PROCTORING_TYPE.PRACTICE);
  } else if (examAPI.exam.recordOnly) {
    return enumKeyByValue(PROCTORING_TYPE.RECORD_ONLY);
  } else {
    return enumKeyByValue(PROCTORING_TYPE.FULL_PROCTORING);
  }
}

export function getSecureBrowserSettings({
  exam,
  whitelistedUrls,
}: examsApi.ExamAPI): ExamFormValues['secureBrowserSettings'] {
  return {
    enabled: exam.enableSecureBrowser,
    disableNavigation: exam.disableNavigation,
    disablePrintScreen: exam.disablePrintScreen,
    disableCopyPaste: exam.disableCopyPaste,
    forceFullScreen: exam.forceFullScreen,
    enableWhitelistedUrls: exam.enableWhitelistedUrls,
    whitelistedUrls: whitelistedUrls,
  };
}
